import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../lib/animations';

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  subtitle: string;
  align?: 'center' | 'left';
  dark?: boolean;
}

// Título de seção reutilizável com badge opcional e animação de entrada
const SectionTitle: React.FC<SectionTitleProps> = ({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  dark = false,
}) => (
  <motion.div
    className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : 'text-left'}`}
    variants={fadeInUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
  >
    {eyebrow && (
      <span className="mb-3 inline-block rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-600">
        {eyebrow}
      </span>
    )}
    <h2
      className={`text-3xl font-bold tracking-tight sm:text-4xl ${
        dark ? 'text-white' : 'text-gray-900'
      }`}
    >
      {title}
    </h2>
    <p
      className={`mt-4 text-base leading-relaxed sm:text-lg ${
        dark ? 'text-gray-400' : 'text-gray-500'
      }`}
    >
      {subtitle}
    </p>
  </motion.div>
);

export default SectionTitle;

